var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramRoundedColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20Z",
    fill: "url(#paint0_linear_1050_15061)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5181 5.22217H8.48587C6.68721 5.22217 5.22632 6.68306 5.22632 8.48172V12.5139C5.22632 14.3126 6.68721 15.7735 8.48587 15.7735H12.5181C14.3168 15.7735 15.7777 14.3126 15.7777 12.5139V8.48172C15.7777 6.68306 14.3168 5.22217 12.5181 5.22217ZM14.5997 12.5182C14.5997 13.6666 13.6665 14.6039 12.5139 14.6039H8.48165C7.33321 14.6039 6.39587 13.6708 6.39587 12.5182V8.48595C6.39587 7.3375 7.32898 6.40017 8.48165 6.40017H12.5139C13.6623 6.40017 14.5997 7.33328 14.5997 8.48595V12.5182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 7.802C9.01415 7.802 7.80237 9.01378 7.80237 10.5C7.80237 11.9862 9.01415 13.198 10.5004 13.198C11.9866 13.198 13.1984 11.9862 13.1984 10.5C13.1984 9.01378 11.9866 7.802 10.5004 7.802ZM10.5004 12.1382C9.59681 12.1382 8.86215 11.4036 8.86215 10.5C8.86215 9.59645 9.59681 8.86178 10.5004 8.86178C11.4039 8.86178 12.1386 9.59645 12.1386 10.5C12.1386 11.4036 11.4039 12.1382 10.5004 12.1382Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4035 8.09769C13.6521 8.0574 13.8209 7.82323 13.7806 7.57466C13.7403 7.32609 13.5061 7.15725 13.2576 7.19755C13.009 7.23784 12.8402 7.47201 12.8805 7.72058C12.9207 7.96915 13.1549 8.13799 13.4035 8.09769Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1050_15061",
    x1: 3.26645,
    y1: 17.7336,
    x2: 16.767,
    y2: 4.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramRoundedColor);
export default __webpack_public_path__ + "static/media/InstagramRoundedColor.2a72ab5fdac9f257745d53321f56298c.svg";
export { ForwardRef as ReactComponent };